export default "__VITE_ASSET__864a5121__"